import Layout from "../Layout";

const Contact = () => {
  return (
    <Layout>
      <h1 style={{ margin: "5rem 0", textAlign: "center" }}>Contact Page</h1>
    </Layout>
  );
};

export default Contact;
